import moment from "moment";
import format from "string-template";
import { CONTACT_POINT_SYSTEM, DATE_FORMAT, REGEX_EXPS } from "utils/constants";
import {
  createContractNumberValidation,
  normalizeTextField,
} from "utils/helpers/validations";
import * as yup from "yup";

const validation = (
  messages,
  { deltaRia, deltaStart, deltaEnd, deltaEndRia },
) => {
  const requiredString = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);
  const contractNumber = createContractNumberValidation(messages, REGEX_EXPS);

  return yup.object().shape({
    project: yup.object().shape({
      ria: yup.boolean().optional(),
      fields: yup.object().shape({
        selfOccupation: yup.boolean().nullable().optional(),
      }),
      contact: yup.object().shape({
        fields: yup.object().shape({
          familySituation: requiredString,
        }),
        socialRegime: requiredString,
        socioProfessionalCategory: requiredString,
        acceptContact: yup
          .boolean()
          .required(messages.REQUIRED)
          .oneOf([true], messages.REQUIRED),
        user: yup.object().shape({
          birthDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED)
            .max(moment().subtract(18, "years").endOf("year"), messages.AGE_18)
            .min(moment().subtract(75, "years").endOf("year"), messages.AGE_75),
        }),
      }),
      contract: yup.mixed().when("ria", {
        is: (ria) => {
          return ria;
        },
        then: yup.object().shape({
          issuanceDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .min(
              moment().startOf("day").add(deltaRia, "days"),
              format(messages.MIN_DATE, {
                date: moment().add(deltaRia, "days").format(DATE_FORMAT),
              }),
            )

            .required(messages.REQUIRED),
        }),
        otherwise: yup.object().shape({
          issuanceDate: yup
            .date()
            .typeError(messages.REQUIRED)
            .min(
              moment().startOf("day").add(deltaStart, "days"),
              format(messages.MIN_DATE, {
                date: moment().add(deltaStart, "days").format(DATE_FORMAT),
              }),
            )
            .required(messages.REQUIRED),
        }),
      }),
      terminationRequest: yup
        .mixed()
        .nullable()
        .when("fields.selfOccupation", {
          is: false,
          then: yup.object().shape({
            // dueDate: yup
            //   .date()
            //   .typeError(messages.REQUIRED)
            //   .required(messages.REQUIRED),
            contractNumber,
            address: yup
              .string()
              .transform(normalizeTextField)
              .typeError(messages.REQUIRED)
              .required(messages.REQUIRED),
            brokerageMandate: yup.object().shape({
              currentCompany: yup
                .string()
                .transform(normalizeTextField)
                .typeError(messages.REQUIRED)
                .required(messages.REQUIRED),
            }),
          }),
          otherwise: yup.object().nullable().notRequired(),
        }),
    }),
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: yup
          .string()
          .typeError(messages.REQUIRED)
          .required(messages.REQUIRED)
          .matches(REGEX_EXPS.zipCode, {
            message: messages.INVALID_VALUE,
            excludeEmptyString: true,
          }),
      }),
    }),
  });
};

export default validation;
